import { axiosInstance } from './axiosInstance';

export const getCompanyTree = () =>
    axiosInstance
        .get('company/loggedInCompany/companyTree')
        .then(response => response.data)
        .catch(error => {
            throw error;
        });
